import { RootState } from 'app/store';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccordion, triggerAccordion } from './accordionSlice';
import { AccordionTheme } from './accordion-theme';
import { getThemeClasses } from './accordion-functions';

export const AccordionItem: FC<{
  id: string;
  HeaderComponent: FC<any>;
  headerContent: {
    [key: string]:
      | string
      | number
      | boolean
      | undefined
      | string[]
      | JSX.Element;
  };
  children: JSX.Element | JSX.Element[] | undefined;
  theme: AccordionTheme;
}> = ({ id, HeaderComponent, headerContent, children, theme }) => {
  const { isOpen } = useSelector((state: RootState) =>
    selectAccordion(state, id)
  );
  const dispatch = useDispatch();
  const { backgroundColourClass, borderColourClass } = getThemeClasses(theme);
  return (
    <div
      className={`rounded border-neutral-200 border mb-2 relative ${borderColourClass}`}
    >
      <div className={`overflow-hidden`}>
        <button
          id={id}
          className={`rounded flex w-full  pr-10 relative z-20 overflow-hidden ${backgroundColourClass}`}
          onClick={() => {
            dispatch(triggerAccordion({ componentId: id }));
          }}
        >
          {HeaderComponent ? <HeaderComponent {...headerContent} /> : <h1></h1>}

          <div className="text-xs absolute right-5 top-1/2 -translate-y-1/2">
            <i
              className={`ra-icons-generic-down-arrow block transition-all ${
                isOpen ? 'rotate-180' : ''
              }`}
            ></i>
          </div>
        </button>
      </div>

      <div
        className={`bg-white rounded-b transition-all overflow-hidden ${
          isOpen ? 'max-h-[9999px]' : 'max-h-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default AccordionItem;
